import {useInjex} from '@injex/react-plugin';
import ReportingBuildManager from "../../managers/reportingBuildManager.mdl";

export default function useReportingBuildManager(): ReportingBuildManager {
    const [inject] = useInjex();
    return inject<ReportingBuildManager>('reportingBuildManager');
}
